//
//
//
//
//
//
//

import Card from "@/components/common/card.comp.vue";
export default {
  name: "Cast",
  data(){
    return {
      person:true
    }
  },
  props: {
    casts: Array
  },
  components: {
    Card
  }
};
